import {
    postCostProviderLoading,
    postCostProviderRequest,
    postCostProviderSuccess,
    postCostProviderReject,
    postCostProviderReset
} from "../../actions/costProvider/post";

export const postCostProvider = (formData) => async (dispatch, getState) => {
    dispatch(postCostProviderLoading());
    try {
        const { data } = await postCostProviderRequest(formData, getState);
        dispatch(postCostProviderSuccess(data))
    } catch (error) {
        dispatch(postCostProviderReject(error))
    } finally {
        setTimeout(() => { dispatch(postCostProviderReset()) }, 3000);
    }
    return Promise.resolve();
};